import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface OnboardingNudgeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCompleteSetup: () => void;
  onSkip: () => void;
}

const OnboardingNudgeDialog = ({
  open,
  onOpenChange,
  onCompleteSetup,
  onSkip,
}: OnboardingNudgeDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle>Complete your streaming setup</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-2 pt-2">
          <Button className="w-full gap-2" onClick={onCompleteSetup}>
            Complete setup <ArrowRight className="w-4 h-4" />
          </Button>
          <Button
            variant="ghost"
            className="w-full text-xs text-muted-foreground/60 hover:text-foreground hover:bg-transparent"
            onClick={onSkip}
          >
            Not now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OnboardingNudgeDialog;
